import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import FrictionSection from "@/components/site/FrictionSection";
import HowItWorksSection from "@/components/site/HowItWorksSection";
import ProofSection from "@/components/site/ProofSection";
import FooterCTA from "@/components/site/FooterCTA";
import SiteFooter from "@/components/site/SiteFooter";

export default function Landing() {
  return (
    <div
      className="min-h-screen bg-[#F4F3EE] text-[#111418] selection:bg-[#D67229] selection:text-white"
      data-testid="landing-page"
    >
      <Navbar />
      <main>
        <Hero />
        <FrictionSection />
        <HowItWorksSection />
        <ProofSection />
        <FooterCTA />
      </main>
      <SiteFooter />
    </div>
  );
}
